// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__23cnt","large":"styles_large__2CuMP"};